import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '@alphapoint/apex-web/lib/components/common/Modal/Modal';
import KYCSumSubSdkContainer from './KYCSumSubSdkContainer';

const KYCSumSubModal = ({ isOpen, onCancel }) => {
  const { t } = useTranslation('kyc');
  return (
    <Modal
      customClass="modal-sumsub"
      title={t('SumSub Validation')}
      isOpen={!!isOpen}
      onCancel={onCancel}
      close={onCancel}>
      <KYCSumSubSdkContainer />
    </Modal>
  );
};

export default KYCSumSubModal;
